"use strict";
/*
 * Copyright (C) 2021 JET PROTOCOL HOLDINGS, LLC.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GovRealm = void 0;
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
class GovRealm {
    /**
     * Creates an instance of GovRealm.
     * @private
     * @param {GovClient} client
     * @param {PublicKey} address
     * @param {PublicKey} owner
     * @param {PublicKey} authority
     * @param {PublicKey} vault
     * @memberof GovRealm
     */
    constructor(client, address, owner, authority, vault) {
        this.client = client;
        this.address = address;
        this.owner = owner;
        this.authority = authority;
        this.vault = vault;
    }
    /**
     * TODO:
     * @static
     * @param {GovClient} client
     * @param {PublicKey} address
     * @returns {Promise<GovRealm>}
     * @memberof GovRealm
     */
    static async load(client, address) {
        const data = await client.program.account.realm.fetch(address);
        return this.decode(client, address, data);
    }
    /**
     * TODO:
     * @memberof GovRealm
     */
    async refresh() {
        const realm = await GovRealm.load(this.client, this.address);
        this.address = realm.address;
        this.owner = realm.owner;
        this.authority = realm.authority;
        this.vault = realm.vault;
    }
    /**
     * TODO:
     * @private
     * @static
     * @param {GovClient} client
     * @param {PublicKey} address
     * @param {any} data
     * @returns {GovRealm}
     * @memberof GovRealm
     */
    static decode(client, address, data) {
        return new GovRealm(client, address, data.owner, data.authority, data.vault);
    }
    // TODO: init_realm.rs - checked
    /**
     * Create the populated transaction instruction for `initRealm`.
     * @param {GovRealm} realm
     * @param {PublicKey} governanceTokenMint
     * @param {{ authority: number; vault: number }} bumpSeeds
     * @returns {Promise<TransactionInstruction>}
     * @memberof GovRealm
     */
    createRealmIx(realm, governanceTokenMint, bumpSeeds) {
        return this.client.program.methods
            .initRealm(bumpSeeds)
            .accounts({
            realm: realm.address,
            owner: realm.owner,
            authority: realm.authority,
            vault: realm.vault,
            governanceTokenMint: governanceTokenMint,
            tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            systemProgram: web3_js_1.SystemProgram.programId,
            rent: web3_js_1.SYSVAR_RENT_PUBKEY
        })
            .instruction();
    }
}
exports.GovRealm = GovRealm;
//# sourceMappingURL=realm.js.map